<div class="preview-container" #modalContainer>
  <div class="content-wrapper">
    <div class="inner-wrapper">
      <div class="modal-inner-container" id="modalInnerContainer" [ngClass]="{'countries' : modalType === 'countries'}">
        <div class="header-modal" *ngIf="!isTitleHidden">
          <div class="flex-header">
            <h3 class="modal-description">{{ modalDescriptionName ?? '' | translate }}</h3>
            <div class="campaign-name" *ngIf="modalType !== 'countries' && modalType !== 'postback_url' && modalType !== 'postback_test'">
              <h4 class="modal-name">{{ campaignData?.name }}</h4>
            </div>
          </div>
          <h1 class="modal-title">{{ modalTitle | translate }}</h1>
        </div>
        <div class="container-modal">
          <ng-container *ngIf="modalType === 'verification'">
            <app-verification-modal
              *ngIf="!(campaignData?.exclusive && !campaignData?.exclusive_user_has_access); else noAccess"
              [currentCampaign]="campaignData"
              [couponModal]="couponModal">
            </app-verification-modal>
            <ng-template #noAccess>
              <app-join-program-alert
                class="add-traffic-source"
                [type]="'info'"
                [containerTextTitle]="{withTranslation: true, text: 'exclusive_contact_support'}">
              </app-join-program-alert>
            </ng-template>
          </ng-container>
          <app-add-edit-config-modal
            *ngIf="modalType === 'add_configuration'"
            [currentCampaign]="campaignData"
            [landingOptionsData]="landingOptionsData"
            [configurationData]="$any(configurationData)"
            [configURL]="configURL"
            [configID]="editedElementID"
            [shortVersionWithoutSecondStep]="shortVersionWithoutSecondStep"
            (emitAction)="emitActionForward($event)">
          </app-add-edit-config-modal>
          <app-banners-list-modal
            *ngIf="modalType === 'banners_list'"
            [currentCampaign]="campaignData"
            [bannerConfigOnly]="bannerConfigOnly"
            [selectedBannerData]="selectedBannerData"
            (bannerConfigVisible)="switchTitleVisibility($event)"></app-banners-list-modal>
          <app-deep-link-modal *ngIf="modalType === 'deep_link'" [currentCampaign]="campaignData"> </app-deep-link-modal>
          <app-postback-url-modal
            *ngIf="modalType === 'postback_url'"
            [currentCampaign]="campaignData"
            [configurationData]="$any(configurationData)"></app-postback-url-modal>
          <app-postback-test-modal *ngIf="modalType === 'postback_test'" [postbackTestData]="postbackTestData"></app-postback-test-modal>
          <app-products-modal
            *ngIf="modalType === 'products'"
            [currentCampaign]="campaignData"
            (productConfigurationVisible)="switchTitleVisibility($event)"></app-products-modal>
          <app-countries-modal
            [onCountryClick]="onCountryClick"
            *ngIf="modalType === 'countries'"
            [currentCampaign]="campaignData"
            [watchInactiveCountries]="watchInactiveCountries"></app-countries-modal>
          <app-traffic-source-modal *ngIf="modalType === 'add_traffic_source'"></app-traffic-source-modal>
          <app-generate-url-modal
            *ngIf="modalType === 'generate_url'"
            [currentCampaign]="campaignData"
            [configURL]="configURL"
            [configID]="configID"
            [configurationType]="configurationType">
          </app-generate-url-modal>
          <app-category-modal *ngIf="modalType === 'categories'" [currentCampaign]="campaignData"></app-category-modal>
        </div>
        <div class="modal-inner-container-mask" *ngIf="longInnerContainer"></div>
      </div>
      <button class="btn close-button" (click)="closeModal()">
        <nb-icon icon="cross" pack="icomoon" class="cross-icon"></nb-icon>
      </button>
    </div>
  </div>
</div>
